module.exports = __webpack_public_path__ + "static/simple-area-1b9b0fada0447e8a31310cb53588cdc6.png";